import { ModalShell } from './ModalShell'
import { useManagersMonthly } from './useDrilldown'

function formatRub(n: number): string {
  if (n === 0) return '—'
  if (Math.abs(n) >= 1_000_000) return `₽ ${(n / 1_000_000).toFixed(1)}M`
  if (Math.abs(n) >= 1_000) return `₽ ${Math.round(n / 1_000)}K`
  return `₽ ${Math.round(n)}`
}

export function AllManagersModal({
  onClose,
  onPickManager,
}: {
  onClose: () => void
  onPickManager: (id: string) => void
}) {
  const { data, isLoading, isError } = useManagersMonthly(true)

  return (
    <ModalShell
      title="Менеджеры"
      subtitle={
        data
          ? `${data.monthLabel} · показано всего: ${data.managers.length}`
          : 'Текущий календарный месяц'
      }
      onClose={onClose}
      size="lg"
    >
      {isLoading && <p className="text-sm text-gray-400">Загрузка…</p>}
      {isError && <p className="text-sm text-red-600">Не удалось загрузить данные</p>}
      {data && data.managers.length === 0 && (
        <p className="text-sm text-gray-400">Активных менеджеров не найдено</p>
      )}
      {data && data.managers.length > 0 && (
        <div className="overflow-x-auto -mx-1">
          <table className="w-full text-sm">
            <thead className="sticky top-0 bg-white">
              <tr className="text-xs text-gray-500 border-b border-gray-200">
                <th className="text-left font-normal py-2 px-2">Менеджер</th>
                <th className="text-right font-normal py-2 px-2">Клиентов</th>
                <th className="text-right font-normal py-2 px-2">Заявок</th>
                <th className="text-right font-normal py-2 px-2">Сумма КП</th>
                <th className="text-right font-normal py-2 px-2">В заказ</th>
              </tr>
            </thead>
            <tbody>
              {data.managers.map((m) => (
                <tr
                  key={m.id}
                  className="border-b border-gray-100 hover:bg-gray-50 cursor-pointer"
                  onClick={() => onPickManager(m.id)}
                >
                  <td className="py-2 px-2">
                    <div className="text-gray-900 font-medium">{m.name}</div>
                    <div className="text-xs text-gray-400">{m.email}</div>
                  </td>
                  <td className="py-2 px-2 text-right tabular-nums text-gray-700">
                    {m.clientsCount}
                  </td>
                  <td className="py-2 px-2 text-right tabular-nums text-gray-700">
                    {m.requestsCount}
                  </td>
                  <td className="py-2 px-2 text-right tabular-nums text-gray-900 font-medium">
                    {formatRub(m.kpSumRub)}
                  </td>
                  <td className="py-2 px-2 text-right tabular-nums text-emerald-700 font-medium">
                    {formatRub(m.wonSumRub)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </ModalShell>
  )
}
